<style scoped lang="scss" type="text/scss">
    .information-container {
        display: flex;
        align-items: flex-start;
        position: absolute;
        width: 100%;
        height: 100%;

        .session-selector-panel-wrap {
            width: 15rem;
            max-height: 100%;
            overflow: auto;
            margin-right: 1rem;
        }

        .content-wrap {
            flex: 1;
            max-height: 100%;
            overflow: hidden;
            display: flex;
            flex-direction: column;

            .content-container {
                flex: 1;
                margin-top: 1rem;
                display: flex;
                align-items: flex-start;
                width: 100%;
                overflow: auto;
            }
        }
    }
</style>

<template>
    <div class="information-container">
        <card class="session-selector-panel-wrap">
            <entered-session-selector-panel></entered-session-selector-panel>
        </card>
        <div class="content-wrap">
            <competition-entered-player-selector></competition-entered-player-selector>
            <card class="content-container">
                <router-view v-if="currentEnteredPlayerId"></router-view>
                <placeholder v-else>请选择赛事</placeholder>
            </card>
        </div>
    </div>
</template>

<script>
    import Card from '@/components/card/index';
    import EnteredSessionSelectorPanel from '@/pages/sub-components/session-selector-panel/entered';
    import CompetitionEnteredPlayerSelector from '@/pages/sub-components/competition-entered-player-selector';
    import {mapState} from 'vuex';
    import Placeholder from '@/components/placeholder';

    export default {
        name: '',
        components: {
            Card,
            EnteredSessionSelectorPanel,
            CompetitionEnteredPlayerSelector,
            Placeholder
        },
        data () {
            return {};
        },
        computed: {
            ...mapState('player', {
                currentEnteredPlayerId: state => state.currentEnteredPlayerId
            })
        }
    };
</script>
